// Variables
export const OD_Free = 0;
export const Wire_Dia = 1;
export const Coils_T = 2;
export const Initial_Tension = 3;
export const End_Extension = 4;
export const Force_1 = 5;
export const Force_2 = 6;
export const Mean_Dia = 7;
export const ID_Free = 8;
export const Coils_A = 9;
export const Rate = 10;
export const Deflect_1 = 11;
export const Deflect_2 = 12;
export const L_Body = 13;
export const L_Free = 14;
export const L_1 = 15;
export const L_2 = 16;
export const L_Stroke = 17;
export const Weight = 18;
export const Spring_Index = 19;
export const Stress_Initial = 20;
export const Stress_1 = 21;
export const Stress_2 = 22;
export const Stress_Hook = 23;
export const FS_2 = 24;
export const FS_CycleLife = 25;
export const FS_Hook = 26;
export const Cycle_Life = 27;
export const PC_Safe_Deflect = 28;
export const Stress_Init_Lo = 29;
export const Stress_Init_Hi = 30;
export const Energy = 31;
export const Spring_Type = 32;
export const Prop_Calc_Method = 33;
export const Material_Type = 34;
export const ASTM_Fed_Spec = 35;
export const Process = 36;
export const Material_File = 37;
export const Life_Category = 38;
export const Density = 39;
export const Torsion_Modulus = 40;
export const Hot_Factor_Kh = 41;
export const Tensile = 42;
export const PC_Tensile_Endur = 43;
export const PC_Tensile_Stat = 44;
export const PC_Tensile_Bend = 45;
export const Stress_Lim_Endur = 46;
export const Stress_Lim_Stat = 47;
export const Stress_Lim_Bend = 48;
export const SI_Range = 49;
export const SI_Lo_Factor = 50;
export const SI_Hi_Factor = 51;
export const End_Type = 52;
export const End_ID = 53;
export const Extended_End_ID = 54;
export const L_End = 55;
export const L_Extended_End = 56;
export const Hook_Deflect_All = 57;
export const Catalog_Name = 58;
export const Catalog_Number = 59;
export const tbase010 = 60;
export const tbase400 = 61;
export const const_term = 62;
export const slope_term = 63;
export const tensile_010 = 64;

// Labels (Properties)
export const COMMENT = 0;
export const Contact_person = 1;
export const Company_name = 2;
export const Street = 3;
export const City__State___Zip = 4;
export const Phone___email = 5;
export const Date = 6;
export const Part_Number = 7;
export const Data_Source = 8;
export const Mandril = 9;
export const Wind = 10;
export const Relative_loop_pos____tol_ = 11;
export const Gaps = 12;
export const Shot_peen = 13;
export const Stress_relieve_HT = 14;
export const Finish = 15;
export const End_use = 16;
export const Operating_temp = 17;
export const Special_notes___tol = 18;
export const Customer_approval = 19;
export const Customer_date = 20;
export const Vendor_approval = 21;
export const Vendor_date = 22;